import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function personalStageReducer() {
    return combineReducers({
        PersonalStage_WorkStageSubForNewPO: createItemReducer("PersonalStage", "PersonalStage.WorkStageSubForNewPO", false),
        PersonalStage_WorkStageSubForNewPOParams: createItemReducerParams("PersonalStage", "PersonalStage.WorkStageSubForNewPO"),
        PersonalStage_WorkStageSubForNewPO_Slav: createItemReducer("PersonalStage", "PersonalStage.WorkStageSubForNewPO_Slav", false),
        PersonalStage_WorkStageSubForNewPO_SlavParams: createItemReducerParams("PersonalStage", "PersonalStage.WorkStageSubForNewPO_Slav"),
        PersonalStage_WorkListForPONew: createItemReducer("PersonalStage", "PersonalStage.WorkListForPONew", false)
    });
}